import merge from 'lodash/merge.js';
import {
  Node
} from './trie.js';
import {
  getKeys
} from '../helper/index.js';

/**
 *
 * Node = {
 *   data, // Object
 *   children: map[string, Node]
 * }
 *
 */

/**
 *
 * value = {
 *   dataPath,
 *   data,
 *   children,
 * }
 *
 */
const newObjectTrie = (value) => {
  return createObjectTrieNode('', null, value);
};

const createObjectTrieNode = (key, parent, item) => {
  const data = getData(item);

  const node = new Node(data, key, parent);

  for (let k in item.children) {
    // validate k
    if (/\./.test(k)) {
      throw new Error('key contains special character "."');
    }
    node.children[k] = createObjectTrieNode(k, node, item.children[k]);
  }

  return node;
};

const getData = (item) => {
  if (!item.data || typeof item.data !== 'object') {
    throw new Error('data is not an object');
  }

  let v = item.data;
  const keys = getKeys(item.dataPath || '');
  for (let i = keys.length - 1; i >= 0; i--) {
    v = {
      [keys[i]]: v
    };
  }

  return v;
};

const get = (trie, path) => {
  const keys = getKeys(path);

  let data = merge({}, trie.data);

  let cur = trie;
  for (let i = 0; i < keys.length; i++) {
    cur = cur.children[keys[i]];
    if (!cur) {
      throw new Error(`can't find node at path ${path}`);
    }
    data = merge(data, cur.data);
  }

  return data;
};

const getList = (trie, path) => {
  let data = get(trie, path);
  const node = trie.findNode(path);

  return getLeavesData(node, data);
};

const getLeavesData = (node, data) => {
  if (node.isLeaf()) {
    return [data];
  }

  let leavesData = [];
  for (let k in node.children) {
    leavesData = leavesData.concat(getLeavesData(node.children[k], merge({}, data, node.children[k].data)));
  }

  return leavesData;
};

const getAllPaths = (trie) => {
  return trie.getPaths();
};

export {
  newObjectTrie,
  get,
  getList,
  getAllPaths,
};
